import ReactDOM from 'react-dom/client';
import ReactModal from 'react-modal';

import { Router } from './Router';

import './i18n/config';
import './index.scss';

// Tell react-modal which element to apply aria-hidden to when modals open.
// Required so screen readers don't read the page underneath an open modal.
ReactModal.setAppElement('#root');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<Router />);
